import React from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Divider,
  stepLabelClasses,
  styled,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import NoLongerFaceIssueButton from "../no_longer_face_issue/no_longer_face_issue_button.component";
import ResolutionDetails from "../resolution_details/resolution_details";
import CustomChip from "../../components/custom_chip.component";
import { formatDate } from "../../../utils";

function IncidentDetail({ details }) {
  const {
    caseNumber,
    status,
    progress,
    item,
    description,
    issue,
    topic,
    createdDate,
    // isResolved, //commenting this out for future use
    resolutionDetails,
    attachments,
    id,
  } = details;

  const steps = [
    "Submitted",
    "In progress",
    "Pending confirmation",
    "Closed",
  ];
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    switch (progress) {
      case "Submitted":
        return setActiveStep(0);
      case "Pending Response":
      case "In Progress":
        return setActiveStep(1);
      case "Pending Confirmation":
      case "Resolved":
        return setActiveStep(2);
      case "Closed":
      case "Cancelled":
        return setActiveStep(3);
      default:
        return setActiveStep(-1);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // custom UI for status bar
  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    //status bar connector color
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 10px)",
      right: "calc(50% + 10px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#D0D0D0",
      },
    },
    // [`&.${stepConnectorClasses.completed}`]: {
    //   [`& .${stepConnectorClasses.line}`]: {
    //     borderColor: "#376EEE",
    //   },
    // },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D0D0D0",
      borderTopWidth: 2,
      borderRadius: 1,
    },
  }));

  const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    // status bar icon
    color: "#d0d0d0",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#d0d0d0",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#376EEE",
      width: 12,
      height: 12,
      borderRadius: "50%",
      backgroundColor: "#376EEE",
    },
    "& .QontoStepIcon-circle": {
      width: 12,
      height: 12,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  }));
  const QontoStepIcon = (props) => {
    const {
      active,
      // completed,
      className,
    } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {active ? (
          <div className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  };
  const ColorlibStepLabel = styled(StepLabel)(() => ({
    // status bar label
    [`& .${stepLabelClasses.label}`]: {
      // [`&.${stepLabelClasses.completed}`]: {
      //   fontSize: "10px",
      // },
      [`&.${stepLabelClasses.active}`]: {
        fontSize: "10px",
        fontWeight: "400",
      },

      color: "#4D4D4D",
      fontSize: "10px",
      // position: "absolute",
      // padding: "0px",
      // margin: "0px",
      // top: "30px",
      // display: " table-cell",
      // verticalAlign: "middle",
    },
  }));

  // displaying different resolution component depending on the status
  const displayResolutionDetails = (status, resolutionDetails) => {
    switch (status) {
      case "Submitted":
      case "Pending Response":
        return <NoLongerFaceIssueButton />;
      case "In Progress":
        return resolutionDetails ? (
          <ResolutionDetails
            resolutionDetails={resolutionDetails}
            status={status}
          />
        ) : (
          <div style={{ paddingBottom: "100px" }}></div>
        );
      case "Pending Confirmation":
      case "Resolved":
        return (
          <ResolutionDetails
            resolutionDetails={resolutionDetails}
            status={status}
          />
        );
      default:
        return <p> </p>;
    }
  };
  const noItem = item === " | " || !item

  const truncateFilename = (filename) => {
    const lastDotIndex = filename.lastIndexOf(".");

    let name, extension;

    if (lastDotIndex !== -1) {
      name = filename.substring(0, lastDotIndex);
      extension = filename.substring(lastDotIndex);
    } else {
      name = filename;
      extension = "";
    }

    if (name.length > 15) {
      const firstPart = name.substring(0, 10);
      const lastPart = name.substring(name.length - 3);
      return `${firstPart}...${lastPart}${extension}`;
    } else {
      return filename;
    }
  };


  return (
    <Box sx={{ padding: "0px", marginTop: '56px' }}>
      <Box sx={{ padding: "16px", backgroundColor: "#F8F8F8" }}>
        <Box sx={styles.greyContainer}>
          <CustomChip status={status} />

          {/* {status === "Pending user's response" ? (
            <Link to={`/chat_page`} style={{ textDecoration: "none" }}>
              <img src={require("../img/../../activityIcon.png")} />
            </Link>
          ) : (
            ""
          )} */}
        </Box>
        <h6 style={styles.ticketNumberStyle}>{caseNumber}</h6>
        <Box sx={{ background: "white", borderRadius: "8px", padding: "16px" }}>
          <Stepper
            nonLinear
            alternativeLabel
            activeStep={activeStep}
            connector={<QontoConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <ColorlibStepLabel StepIconComponent={QontoStepIcon}>
                  {label}
                </ColorlibStepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>

      <Box>
        <Box sx={{ padding: "16px" }}>
          <p className="pLabel">Date Submitted</p>
          <h6 className="detailContent">{formatDate(createdDate)}</h6>
          <p className="pLabel">Topic</p>
          <h6 className="detailContent">{topic ?? "-"}</h6>
          <p className="pLabel">Issue</p>
          <h6 className="detailContent">{issue ?? "-"}</h6>
          <p className="pLabel">Device experiencing the issue</p>
          <h6 className="detailContent">{noItem ? '-' : item}</h6>
          <p className="pLabel">Description</p>
          <h6 className="detailContent">{!description.length ? '-' : description}</h6>
          {!!attachments.length && (
            <>
              <p className="pLabel">Attachments</p>
              {attachments.map((file) => (
                <div style={styles.attachmentContainer}>
                  <AttachFileIcon style={styles.fileIcon} />
                  <Typography style={styles.attachment}>
                    {truncateFilename(file)}
                  </Typography>
                </div>
              ))}
              <Typography style={styles.attachmentSubtitle}>
                To view the file/s, please go to https://home.itsm.gov.sg/sp on
                your GSIB/Comet laptop.
              </Typography>
            </>
          )}
        </Box>
        {/* <Divider /> */}
      </Box>

      {/* {displayResolutionDetails(status, resolutionDetails)} */}
    </Box>
  );
}

const styles = {
  ticketNumberStyle: {
    color: "#4D4D4D",
    fontSize: "16px",
    fontFamily: "Open Sans",
    fontWeight: 600,
    letterSpacing: "0.15px",
    marginTop: "16px",
    marginBottom: "16px",
  },
  greyContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  attachmentContainer: {
    display: "flex",
    flexFlow: "row",
    alignItems: "center",
    marginTop: "12px",
  },
  fileIcon: {
    color: "#AAAAAA",
    fontSize: "20px",
    transform: "rotate(45deg)",
    marginRight: "4px",
  },
  attachment: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#AAAAAA",
    letterSpacing: "0.15px",
  },
  attachmentSubtitle: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    fontStyle: "italic",
    color: "#4D4D4D",
    marginTop: "8px",
  },
};


export default IncidentDetail;
